module.exports = __webpack_public_path__ + "media/images/icon-chart-down-red-92381fa6882f02fe3f87f885555b8977.svg";